export enum OfferingStatus {
  ACTIVE = 'active',
  ARCHIVED = 'archived',
  DRAFT = 'draft',
}

export enum OfferingType {
  PRODUCT = 'product',
  SERVICE = 'service',
}

export interface OfferingProperties {
  accountId: number;
  buyerRoles?: string[];
  createdAt?: Date;
  deletedAt?: Date;
  description?: string;
  differentiators?: string[];
  icps?: string[];
  id: number;
  name: string;
  problemsSolved?: string[];
  status: OfferingStatus;
  type: OfferingType;
  updatedAt?: Date;
  useCases?: string[];
}
